import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LogService } from 'src/app/core/services/log/log.service';
import { FacadeService } from 'src/app/core/services/facade.service';
import { DemandeAdministrative, DemandeAdministrativeString, DureeExecutionByType, ModuleType, MotifRefus, PeriodeExecutionByType, Prestation, PrestationStatut, PrestationStatutString, PrestationType, PrestationTypeString, QualificationEtat, QualificationEtatString, StatutBeneficiaire, StatutBeneficiaireString, TypologieDemande } from 'src/app/shared/models/prestation';
import { Unavailability } from 'src/app/shared/models/unavailability';
import {
	FormGroup,
} from '@angular/forms';
import { Address } from 'src/app/shared/models/address';
import { PARAM_LABEL_INTERVENANT } from 'src/app/core/services/constant/constants.service';
import { User } from 'src/app/shared/models/security/user';
import { Employee } from 'src/app/shared/models/employee/employee';
import { Beneficiaire } from 'src/app/shared/models/beneficiaire';
import { OrigineDemande } from 'src/app/shared/models/origineDemande';
import { Prescripteur } from 'src/app/shared/models/prescripteur';
import { ObjectifPro } from 'src/app/shared/models/objectifPro';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Editor } from 'ngx-editor';
import { TypeFormation } from 'src/app/shared/models/typeFormation';
import { CanalCommunication } from 'src/app/shared/models/canalCommunication';
import { TypeHandicap } from 'src/app/shared/models/typeHandicap';

@Component({
	selector: 'app-prestation-form',
	templateUrl: './prestation-form.component.html',
	styleUrls: ['./prestation-form.component.scss']
})
export class PrestationFormComponent implements OnInit {
	@Input() prestation: Prestation;
	@Input() isAddForm: boolean;
	//Boolean empêchant l'utilisateur d'envoyer plusieurs fois le formulaire
	@Input() isValidateButtonClicked: { value: boolean };
	@Input() form: FormGroup;
	@Output() sendForm: EventEmitter<any> = new EventEmitter();
	@Output() hideModal: EventEmitter<any> = new EventEmitter();

	isHISelected = false;
	isOSSelected = false;
	isDASelected = false;
	isBOSelected = false;
	isDSBSelected = false;

	isReorientationNewPresta;

	isStatutDESelected = false;
	isStatutEESelected = false;
	isStatutEFSelected = false;

	showModal = false;

	MAX_NAME_CHAR = 25;
	NAME_PATTERN = new RegExp("^[a-zA-z'éèàç.-_]+( [a-zA-z'éèàç.-_]+)*$");

	prestations: Prestation[] = null;

	labelIntervenantCapitalized: string;

	listIntervenant: Employee[];
	listSelectedIntervenant: Employee[];

	listModuleEnum = ModuleType;
	listAllModule = Object.keys(this.listModuleEnum);
	listSelectedModule: string[] = [];
	listModules: Prestation[];
	listModuleToCreate: string[] = [];

	isPreferencesActive = false;

	user: User;

	emailActive = false;
	nomStructureActive = false;
	addressStructureActive = false;
	typeStructureActive = false;
	emailStructureActive = false;
	phoneStructureActive = false;
	listBeneficiaire: Beneficiaire[];
	listCanalCommunication: CanalCommunication[];
	listTypeHandicap: TypeHandicap[];
	listOrigineDemande: OrigineDemande[];
	listPrescripteur: Prescripteur[];
	listObjectifPro: ObjectifPro[];
	listTypeFormation: TypeFormation[];

	selectedAddress= new Address();
	selectedTypeHandicaps;

	listSelectedTypeHandicap: TypeHandicap[];

	chooseIntervenantModalref: BsModalRef;

	public PrestationTypeStringEnum = PrestationTypeString;
	public TypologieDemandeEnum = TypologieDemande;
	public MotifRefusEnum = MotifRefus;

	public QualificationEtatStringEnum = QualificationEtatString;
	public QualificationEtatEnum = QualificationEtat;

	public PrestationStatutStringEnum = PrestationStatutString;
	public PrestationStatutEnum = PrestationStatut;

	public StatutBeneficiaireStringEnum = StatutBeneficiaireString;
	public StatutBeneficiaireEnum = StatutBeneficiaire;

	public DemandeAdministrativeStringEnum = DemandeAdministrativeString;
	public DemandeAdministrativeEnum = DemandeAdministrative;

	isAssistant: boolean;
	isIntervenant: boolean;
	editorDemandePrescripteur: Editor;
	editorReponseDemande: Editor;
	editorDeProjetPro: Editor;
	editorDeRuptureParcours: Editor;
	editorDeBesoinsIdent: Editor;
	editorDeContraintesHandicap: Editor;
	editorDeDispositifs: Editor;
	editorEeLimites: Editor;
    editorEeQuestEmploi: Editor;
    editorEeBesoinsAdapt: Editor;
    editorEePbAccess: Editor;
    editorEeAccompDejaMene: Editor;
    editorEeSyntheseSitEmployeur: Editor;
    editorEeHoraires: Editor;
    editorEeFichePoste: Editor;
	editorEfLimiteCapacite: Editor;
    editorEfQuestionnement: Editor;
    editorEfAccompDejaMene: Editor;
    editorEfAccessibilite: Editor;
    editorEfBesoinsAt: Editor;
    editorEfPlanning: Editor;
    editorEfRemarqueRef: Editor;
	editorArgumentaire: Editor;

	constructor(
		private logger: LogService, 
		private facade: FacadeService,
		public bsModalRef: BsModalRef
	) {}

	ngOnInit(): void {
		this.editorDeProjetPro = new Editor();
		this.editorDemandePrescripteur = new Editor();
		this.editorReponseDemande = new Editor();
		this.editorDeRuptureParcours = new Editor();
		this.editorDeBesoinsIdent = new Editor();
		this.editorDeContraintesHandicap = new Editor();
		this.editorDeDispositifs = new Editor();
		this.editorEeLimites = new Editor();
    	this.editorEeQuestEmploi = new Editor();
    	this.editorEeBesoinsAdapt = new Editor();
    	this.editorEePbAccess = new Editor();
    	this.editorEeAccompDejaMene = new Editor();
    	this.editorEeSyntheseSitEmployeur = new Editor();
    	this.editorEeHoraires = new Editor();
    	this.editorEeFichePoste = new Editor();
		this.editorEfLimiteCapacite = new Editor();
    	this.editorEfQuestionnement = new Editor();
    	this.editorEfAccompDejaMene = new Editor();
    	this.editorEfAccessibilite = new Editor();
    	this.editorEfBesoinsAt = new Editor();
    	this.editorEfPlanning = new Editor();
    	this.editorEfRemarqueRef = new Editor();
		this.editorArgumentaire = new Editor();

		if (this.prestation) {
			this.labelIntervenantCapitalized =
				this.facade.dataStorageService.getLabelCapitalized(
					PARAM_LABEL_INTERVENANT
				);

			this.isAssistant = this.facade.dataStorageService.isAssistant();
			this.isIntervenant = this.facade.dataStorageService.isIntervenant();

			this.user = this.facade.dataStorageService.getUser();

			this.isPreferencesActive =
				this.facade.dataStorageService.isPreferencesBeneficiaireActive();

			this.listSelectedTypeHandicap = [...this.prestation.typeHandicaps];

			this.facade.canalCommunicationService.getAllCanalCommunication().subscribe({
				next: (val) => {
					this.listCanalCommunication = val;
				},
				error: (err) => {
					this.logger.error(err);
				}
			});
			this.facade.typeHandicapService.getAllTypeHandicaps().subscribe({
				next: (val) => {
					this.listTypeHandicap = val;
				},
				error: (err) => {
					this.logger.error(err);
				}
			});
			this.facade.prescripteurService.getAllPrescripteurs().subscribe({
				next: (val) => {
					this.listPrescripteur = val;
				},
				error: (err) => {
					this.logger.error(err);
				}
			});
			this.facade.typeFormationService.getAllTypeFormation().subscribe({
				next: (val) => {
					this.listTypeFormation = val;
				},
				error: (err) => {
					this.logger.error(err);
				}
			});
			this.facade.beneficiaireService.getAllBeneficiaires().subscribe({
				next: (val) => {
					this.listBeneficiaire = val;
					if (!this.isAddForm) {
						this.isReorientationNewPresta = this.prestation.reorientation;
						this.form.patchValue({
							statut: this.prestation.statut,
							dateDebut:
								this.prestation.dateDebut !== null && this.prestation.dateDebut !== ''
									? new Date(this.prestation.dateDebut)
									: null,
							dateFin:
								this.prestation.dateFin !== null && this.prestation.dateFin !== ''
									? new Date(this.prestation.dateFin)
									: null,
							dateAr:
									this.prestation.dateAr !== null && this.prestation.dateAr !== ''
										? new Date(this.prestation.dateAr)
										: null,
							prescripteur: this.prestation.prescripteur?.id,
							deContraintesHandicap: this.prestation.deContraintesHandicap,
							deDispositifs: this.prestation.deDispositifs,
							deProjetPro: this.prestation.deProjetPro,
							deRuptureParcours: this.prestation.deRuptureParcours,
							deBesoinsIdent: this.prestation.deBesoinsIdent,
							eeLimites: this.prestation.eeLimites,
							eeQuestEmploi: this.prestation.eeQuestEmploi,
							eeBesoinsAdapt: this.prestation.eeBesoinsAdapt,
							eePbAccess: this.prestation.eePbAccess,
							eeAccompDejaMene: this.prestation.eeAccompDejaMene,
							efLimiteCapacite: this.prestation.efLimiteCapacite,
							efQuestionnement: this.prestation.efQuestionnement,
							efAccessibilite: this.prestation.efAccessibilite,
							efTypeFormation: this.prestation.efTypeFormation,
							efBesoinsAt: this.prestation.efBesoinsAt,
							statutBeneficiaire: this.prestation.statutBeneficiaire,
							typologieDemande: this.prestation.typologieDemande,
							motifRefus: this.prestation.motifRefus,
							demandePrescripteur: this.prestation.demandePrescripteur,
							reponseDemande: this.prestation.reponseDemande,
							typeHandicap: this.prestation.typeHandicap,
							situationGeographique: this.prestation.situationGeographique,
							reorientation: this.prestation.reorientation,
							organismeReorientation: this.prestation.organismeReorientation,
							contactReorientation: this.prestation.contactReorientation,
							canalCommunication: this.prestation.canalCommunication?.id,
							argumentaire: this.prestation.argumentaire,
							numeroCommande: this.prestation.numeroCommande
						});

						this.onTypologieDemandeChanged();
						this.onStatutBeneficiciareChanged();
					} 
				},
				error: (err) => {
					this.logger.error(err);
				}
			});

		}

	}

	isTypeHandicapCheck(spec: TypeHandicap): boolean {
		return this.listSelectedTypeHandicap?.some(
			(specItfc) => specItfc.id === spec.id
		);
	}

	updateSelectedTypeHandicap(e: any, spe: TypeHandicap) {
		if (e.target.checked) {
			if (!this.listSelectedTypeHandicap.some((z) => z.id === spe.id)) {
				this.listSelectedTypeHandicap.push(spe);
			}
		} else {
			if (this.listSelectedTypeHandicap.some((z) => z.id === spe.id)) {
				this.listSelectedTypeHandicap = this.listSelectedTypeHandicap.filter(
					(z) => z.id !== spe.id
				);
			}
		}
	}

	isIntervenantCheck(spec: Employee): boolean {
		return this.listSelectedIntervenant?.some(
			(specItfc) => specItfc.id === spec.id
		);
	}

	/**
	 * Ajoute ou supprime la spécialité à la liste des spécialités sélectionnées
	 * @param e Element html
	 * @param spe String representant la intervenant choisie
	 */
	updateSelectedIntervenant(e: any, spe: Employee) {
		if (e.target.checked) {
			if (!this.listSelectedIntervenant.some((z) => z.id === spe.id)) {
				this.listSelectedIntervenant.push(spe);
			}
		} else {
			if (this.listSelectedIntervenant.some((z) => z.id === spe.id)) {
				this.listSelectedIntervenant = this.listSelectedIntervenant.filter(
					(z) => z.id !== spe.id
				);
			}
		}
	}

	isModuleDisabled(spec: string): boolean {
		return this.listModuleToCreate?.includes(spec);
	}

	isModuleCheck(spec: string): boolean {
		return this.listSelectedModule?.some(
			(specItfc) => specItfc === spec
		);
	}
	

	/**
	 * Ajoute ou supprime la spécialité à la liste des spécialités sélectionnées
	 * @param e Element html
	 * @param spe String representant la expertise choisie
	 */
	updateSelectedModule(e: any, spe: string) {
		 if (e.target.checked) {
			if (!this.listSelectedModule.some((z) => z === spe)) {
				this.listSelectedModule.push(spe);
			}
		} else {
			if (this.listSelectedModule.some((z) => z === spe)) {
				this.listSelectedModule = this.listSelectedModule.filter(
					(z) => z !== spe
				);
			}
		}
	}
		

	submitForm() {
		if (
			this.form.valid
		) {
			this.isValidateButtonClicked.value = true;
			this.bsModalRef.hide();
			this.prestation.intervenants = this.listSelectedIntervenant;
			this.prestation.typeHandicaps = this.listSelectedTypeHandicap;
			this.prestation.dateDebut = new Date(new Date(this.form.get('dateDebut').value).setHours(12,0,0,0)).toISOString();
			this.prestation.dateAr = new Date(new Date(this.form.get('dateAr').value).setHours(12,0,0,0)).toISOString();
			this.prestation.dateFin = new Date(new Date(this.form.get('dateFin').value).setHours(12,0,0,0)).toISOString();
			this.prestation.statut = this.form.get('statut').value;
			this.prestation.canalCommunication = this.listCanalCommunication.find(x => x.id == this.form.get('canalCommunication').value); 
			this.prestation.prescripteur = this.listPrescripteur.find(x => x.id == this.form.get('prescripteur').value);
			this.prestation.deDispositifs= this.form.get('deDispositifs').value;
			this.prestation.deContraintesHandicap= this.form.get('deContraintesHandicap').value;
			this.prestation.deProjetPro= this.form.get('deProjetPro').value;
			this.prestation.deRuptureParcours= this.form.get('deRuptureParcours').value;
			this.prestation.deBesoinsIdent= this.form.get('deBesoinsIdent').value;
			this.prestation.eeLimites= this.form.get('eeLimites').value;
			this.prestation.eeQuestEmploi= this.form.get('eeQuestEmploi').value;
			this.prestation.eeBesoinsAdapt= this.form.get('eeBesoinsAdapt').value;
			this.prestation.eePbAccess= this.form.get('eePbAccess').value;
			this.prestation.eeAccompDejaMene= this.form.get('eeAccompDejaMene').value;
			this.prestation.efLimiteCapacite= this.form.get('efLimiteCapacite').value;
			this.prestation.efQuestionnement= this.form.get('efQuestionnement').value;
			this.prestation.efAccessibilite= this.form.get('efAccessibilite').value;
			this.prestation.efBesoinsAt= this.form.get('efBesoinsAt').value;
			this.prestation.demandePrescripteur= this.form.get('demandePrescripteur').value;
			this.prestation.reponseDemande= this.form.get('reponseDemande').value;
			this.prestation.typologieDemande= this.form.get('typologieDemande').value;
			this.prestation.typeHandicap= this.listTypeHandicap.find(x => x.id == this.form.get('typeHandicap').value);
			this.prestation.statutBeneficiaire = this.form.get('statutBeneficiaire').value;
			this.prestation.motifRefus= this.form.get('motifRefus').value;
			this.prestation.reorientation= this.form.get('reorientation').value;
			this.prestation.organismeReorientation= this.form.get('organismeReorientation').value;
			this.prestation.contactReorientation= this.form.get('contactReorientation').value;
			this.prestation.argumentaire= this.form.get('argumentaire').value;
			this.prestation.numeroCommande= this.form.get('numeroCommande').value;

			if(this.prestation.id){
				this.prestation.modules = this.listSelectedModule.filter(item => this.listModuleToCreate.indexOf(item) < 0);
			}else{
				this.prestation.modules = this.listSelectedModule;
			}

			if(this.prestation.modules?.length > 0){
				this.prestation.prescripionOrientee = true;
				this.prestation.datePrescriptionOrientee = new Date().toISOString();
			}
			this.sendForm.emit();
		} else {
			// this.facade.toastService.createErrorToast();
			this.isValidateButtonClicked.value = false;
		}
	}

	onReorientationChanged(evt){
		this.isReorientationNewPresta = evt.target.checked;
	}

	onStatutBeneficiciareChanged() { 
		switch(this.statutBeneficiaire.value) { 
			// case StatutBeneficiaire.DE: {
			// 	this.isStatutDESelected = true;
			// 	this.isStatutEESelected = false;
			// 	this.isStatutEFSelected = false;
			// 	break;
			// }
			case StatutBeneficiaire.EEPUB: {
				this.isStatutDESelected = false;
				this.isStatutEESelected = true;
				this.isStatutEFSelected = false;
				break;
			}
			case StatutBeneficiaire.EEPRIV: {
				this.isStatutDESelected = false;
				this.isStatutEESelected = true;
				this.isStatutEFSelected = false;
				break;
			}
			case StatutBeneficiaire.EF: {
				this.isStatutDESelected = false;
				this.isStatutEESelected = false;
				this.isStatutEFSelected = true;
				break;
			}
		}
	}

	onTypologieDemandeChanged() {
		switch(this.typologieDemande.value) { 
			case TypologieDemande.HI: { 
			   this.isHISelected = true;
			   this.isOSSelected = false;
			   this.isDASelected = false;
			   this.isBOSelected = false;
			   this.isDSBSelected = false;
			   break; 
			} 
			case TypologieDemande.OS: { 
				this.isHISelected = false;
			   this.isOSSelected = true;
			   this.isDASelected = false;
			   this.isBOSelected = false;
			   this.isDSBSelected = false;
			   break; 
			}
			case TypologieDemande.DA: { 
				this.isHISelected = false;
			   this.isOSSelected = false;
			   this.isDASelected = true;
			   this.isBOSelected = false;
			   this.isDSBSelected = false;
			   break; 
			}
			case TypologieDemande.BO: { 
				this.isHISelected = false;
			   this.isOSSelected = false;
			   this.isDASelected = false;
			   this.isBOSelected = true;
			   this.isDSBSelected = false;
				break; 
			}
			case TypologieDemande.DSB: { 
				this.isHISelected = false;
			   this.isOSSelected = false;
			   this.isDASelected = false;
			   this.isBOSelected = false;
			   this.isDSBSelected = true;
				break; 
			}
			default: { 
			   break; 
			} 
		 } 
	}

	get dateDebut() {
		return this.form.get('dateDebut');
	}
	get dateAr() {
		return this.form.get('dateAr');
	}
	get dateFin() {
		return this.form.get('dateFin');
	}
	get statut() {
		return this.form.get('statut');
	}
	get intervenants() {
		return this.form.get('intervenants');
	}
	get prescripteur() {
		return this.form.get('prescripteur');
	}
	get deContraintesHandicap() {
		return this.form.get('deContraintesHandicap');
	}
	get deDispositifs() {
		return this.form.get('deDispositifs');
	}
	get deProjetPro() {
		return this.form.get('deProjetPro');
	}
	get deRuptureParcours() {
		return this.form.get('deRuptureParcours');
	}
	get deBesoinsIdent() {
		return this.form.get('deBesoinsIdent');
	}
	get eeLimites() {
		return this.form.get('eeLimites');
	}
	get eeQuestEmploi() {
		return this.form.get('eeQuestEmploi');
	}
	get eeBesoinsAdapt() {
		return this.form.get('eeBesoinsAdapt');
	}
	get eePbAccess() {
		return this.form.get('eePbAccess');
	}
	get eeAccompDejaMene() {
		return this.form.get('eeAccompDejaMene');
	}
	get efLimiteCapacite() {
		return this.form.get('efLimiteCapacite');
	}
	get efQuestionnement() {
		return this.form.get('efQuestionnement');
	}
	get efAccessibilite() {
		return this.form.get('efAccessibilite');
	}
	get efTypeFormation() {
		return this.form.get('efTypeFormation');
	}
	get efBesoinsAt() {
		return this.form.get('efBesoinsAt');
	}
	get statutBeneficiaire(){
		return this.form.get('statutBeneficiaire');
	}
	get motifRefus(){
		return this.form.get('motifRefus');
	}
	get typologieDemande(){
		return this.form.get('typologieDemande');
	}
	get nombreDemande() {
		return this.form.get('nombreDemande');
	}
	get demandePrescripteur() {
		return this.form.get('demandePrescripteur');
	}
	get reponseDemande() {
		return this.form.get('reponseDemande');
	}
	get situationGeographique() {
		return this.form.get('situationGeographique');
	}
	get typeHandicap() {
		return this.form.get('typeHandicap');
	}
	get reorientation() {
		return this.form.get('reorientation');
	}
	get organismeReorientation() {
		return this.form.get('organismeReorientation');
	}
	get contactReorientation() {
		return this.form.get('contactReorientation');
	}
	get argumentaire() {
		return this.form.get('argumentaire');
	}
	get numeroCommande() {
		return this.form.get('numeroCommande');
	}
	

	disableChooseEmployeeButton(): boolean{
		if(this.form.get('dateDebut').value != null
			&& this.form.get('dateLimite').value != null
			&& this.form.get('typePrestation').value != ""){
			if(this.form.get('typePrestation').value == PrestationType.QD 
				&& (this.form.get('raison').value == null
				//|| this.form.get('prescripteur').value == ""
				|| this.form.get('situation').value == ""
				|| this.form.get('origineDemande').value == "")){
				return true;
			}
			return false;
		}
		return true;
	}

	openModalChooseEmployee() {
		this.showModal = true;
	}



	
}
